import { TokenLogo } from 'components/common/imager/Imager';
import { PortfolioData } from 'components/strategies/portfolio/usePortfolioData';
import { buildAmountString } from 'components/strategies/portfolio/utils';
import { FC } from 'react';
import { getUsdPrice } from 'utils/helpers';

type Props = {
  data?: PortfolioData;
};

export const PortfolioTokenPieChartCenter: FC<Props> = ({ data }) => {
  // TODO handle error state
  if (!data) return null;

  return (
    <div className="flex flex-col items-center gap-4">
      <div className="font-medium text-18 flex items-center">
        <TokenLogo token={data.token} size={24} className="mr-10" />
        {data.token.symbol}
      </div>
      <div className="text-20 font-medium">{getUsdPrice(data.value)}</div>
      <div className="font-medium text-main-0/60">
        {buildAmountString(data.amount, data.token)}
      </div>
      <div className="font-medium text-main-0/60">
        {getStrategyText(data.strategies.length)}
      </div>
    </div>
  );
};

function getStrategyText(numStrategies: number) {
  const text = numStrategies > 1 ? 'Strategies' : 'Strategy';
  return `${numStrategies} ${text}`;
}
